import React from 'react'
import hotelLocationPagesEU from '../../../../config/hotelLocationPagesEU'
import ProductSelect from './productSelect.jsx'

const HotelSelect = ({id, label = 'Bitte wählen Sie Ihr Flughafen-Hotel aus'}) => (
  <ProductSelect id={id} label={label} options={hotelLocationPagesEU} />
)

export default HotelSelect



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/dropdowns/hotelselectEU.jsx